/* eslint-disable default-param-last */
/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';
import produce from 'immer';
import _ from 'underscore';

import { NotificationRequestTypes, NewNotificationState, NotificationTypes } from './types';

const INITIAL_STATE: NewNotificationState = {
  notifications: [],
  unreadCount: 0,
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const calculateUnreadCount = (notifications: NotificationTypes[]) =>
  notifications.filter((n) => !n.read).length;

const reducer: Reducer<NewNotificationState> = (state = INITIAL_STATE, { rest, type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case NotificationRequestTypes.SHOW_REQUEST:
        draft.request.loading = true;
        break;
      case NotificationRequestTypes.SHOW_SUCCESS:
        if (!result) return;

        draft.notifications = _.uniq(
          [...draft.notifications, ...result.data.notifications],
          (notification) => notification.id,
        );

        draft.unreadCount = calculateUnreadCount(draft.notifications);

        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;

      case NotificationRequestTypes.SHOW_FAILURE:
        draft.notifications = INITIAL_STATE.notifications;
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case NotificationRequestTypes.UPDATE_BIDDINGS_REQUEST:
        draft.request.loading = true;
        break;
      case NotificationRequestTypes.UPDATE_BIDDINGS_SUCCESS:
        if (!result) return;
        draft.notifications = _.uniq(
          [...state.notifications, ...result.data.notifications],
          (notification) => notification.id,
        );
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case NotificationRequestTypes.UPDATE_BIDDINGS_FAILURE:
        draft.notifications = INITIAL_STATE.notifications;
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case NotificationRequestTypes.ADD_SINGLE_NOTIFICATION:
        draft.notifications = _.sortBy(
          _.uniq([...draft.notifications, result]),
          (node: NotificationTypes) => {
            return Date.parse(node.created_at as string);
          },
        ).reverse();
        break;
      case NotificationRequestTypes.READ_NOTIFICATION_REQUEST:
        console.log('carregando');

        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;

      case NotificationRequestTypes.READ_NOTIFICATION_SUCCESS:
        console.log('sucesso');

        const notificationList = [...state.notifications];
        const notificationIndex = notificationList.findIndex(
          (notification: NotificationTypes) => notification.id === rest,
        );

        console.log(typeof notificationList);

        notificationList[notificationIndex] = {
          ...notificationList[notificationIndex],
          read: true,
        };

        console.log(notificationList);

        draft.notifications = notificationList;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;

      case NotificationRequestTypes.READ_NOTIFICATION_FAILURE:
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case NotificationRequestTypes.MARK_ALL_AS_READ:
        draft.notifications.forEach((notification) => {
          notification.read = true;
        });
        draft.unreadCount = 0;
        break;

      default:
    }
  });
};

export default reducer;
